import React from 'react'
import { useUser } from "../../../../hooks/use-user";
import {
  getInstituteLogo,
  getInstituteName,
  getUserInstituteId,
  useInstitute,
} from '../../../../hooks/use-institute';
import QuestionPage from '../Mcq/QuestionPage';
import StartQuizepage2 from '../Mcq/StartQuizepage2';
import OfferContestPopup from './OfferContestPopup';
const DashHome = () => {
    const { data: user } = useUser();
  const { data: institute } = useInstitute(getUserInstituteId(user));
  const instituteName = getInstituteName(institute);
  const instituteLogo = getInstituteLogo(institute);

  return (
    <div className=''>
    <OfferContestPopup />
    {instituteName && (
      <div className="mx-4 mt-4 hidden items-center gap-3 rounded-xl bg-white p-4 shadow-sm lg:flex">
        {instituteLogo && (
          <img
            src={instituteLogo}
            alt={`${instituteName} logo`}
            className="h-12 w-12 rounded-md object-contain"
          />
        )}
        <div>
          <p className="text-xs text-gray-500">Your institute</p>
          <h1 className="text-lg font-semibold text-[#4B2D83]">{instituteName}</h1>
        </div>
      </div>
    )}
    {user?.planName!=="TEST"?<StartQuizepage2/>:<QuestionPage/>}
    </div>
  )
}

export default DashHome
